export const fixContentEditor = (content: string) => {
  return content.replace(/<td style="/g, '<td style="border: 1px solid #000; >');
};
